<template>
    <div class="load"> 
        <img src="../assets/load.gif" class="imgLoad" alt="">
    </div>
</template>
<script>
export default {
    name:'loader'
    
}
</script>
<style>
.imgLoad{
    width: 70%;
    margin: auto;
    display: block;
}
    .load{
       
        background-color: #000;
      /*   background-image:url('../assets/load.gif') ; */
        z-index: 100001;
        position: absolute;
        width: 100%;
        display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
        top: 0;
       
    }
</style>
